import isNil from 'lodash/isNil';

import { IS_CLOUD } from '@qality/common-config';
import { QALITY_TEST_ISSUE_TYPE } from '@qality/common-config/src/constants';

import { AvatarUrls, IssueType } from './Issue';

class Project {
  name: string;
  isPluginEnabled: boolean;
  isAppVisibleInAllIssues: boolean;
  issueTypes: Array<IssueType>;
  style: string;
  key: string;
  id?: string;
  icon: {
    id: string;
  };
  avatarUrls: AvatarUrls;
  isPrivate: boolean;
  archived: boolean;
  constructor(project) {
    Object.assign(this, project);
    this.isPluginEnabled = isNil(this.isPluginEnabled)
      ? true
      : this.isPluginEnabled;
  }

  doesGivenProjectHaveQAlityTest(): boolean {
    return this.issueTypes.some(
      (issueType) => issueType.name === QALITY_TEST_ISSUE_TYPE
    );
  }

  getQAlityTestId(): number {
    const foundIssueType = this.issueTypes.find(
      (issueType) => issueType.name === QALITY_TEST_ISSUE_TYPE
    );

    if (foundIssueType) {
      return foundIssueType.id;
    }
    return null;
  }

  toggleVisibilityInAllIssues(): void {
    this.isAppVisibleInAllIssues = !this.isAppVisibleInAllIssues;
  }

  togglePluginInProject(): void {
    this.isPluginEnabled = !this.isPluginEnabled;
  }

  getIconUrl(): string {
    return IS_CLOUD
      ? this.avatarUrls['24x24']
      : `${window.AJS.contextPath()}/secure/projectavatar?avatarId=${
          this.icon.id
        }`;
  }

  isTeamManaged(): boolean {
    return this.style === 'next-gen';
  }

  getRequestDataToUpdateSettings(): {
    projectKey: string;
    isPluginEnabled: boolean;
    isQalityEnabled: boolean;
  } {
    return {
      projectKey: this.key,
      isPluginEnabled: this.isPluginEnabled,
      isQalityEnabled: this.isAppVisibleInAllIssues,
    };
  }

  getRequestDataToUpdateServerSettings(): {
    isPluginEnabled: boolean;
    enabled: boolean;
  } {
    return {
      isPluginEnabled: this.isPluginEnabled,
      enabled: this.isAppVisibleInAllIssues,
    };
  }
}

export default Project;
